import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';

import { withStyles } from '@material-ui/core';
import styles from './style';
import {
  getDocumentPath,
  getDocumentFileType,
} from '../../../../../utils/documents';
import useDesktop from '../../../../../hooks/useDesktop';
import FileViewer from '../../../../../components/FileViewer';
import Page from '../../../../../components/layouts/WithHeader';
import useFetchEffect from '../../../../../hooks/useFetchEffect';
import ErrorContainer from '../../../../../components/ErrorContainer';
import { fetchPublicDocument as apiFetchDocument } from '../../../../../api/documents';
import ShowErrorMessage from '../../../../../components/ShowErrorMessage';

const Document = ({ classes }) => {
  const [documentPath, setDocumentPath] = useState(null);
  const [isConvertedFile, setIsConvertedFile] = useState(false);

  const isDesktop = useDesktop();
  const { documentId } = useParams();

  const {
    fetching,
    fetchingError,
    data: document,
  } = useFetchEffect({
    dependencies: [documentId],
    apiFetchFunction: () => apiFetchDocument(documentId),
  });

  if (fetchingError) {
    return <ErrorContainer errorResponse={fetchingError} />;
  }
  useEffect(() => {
    if (document) {
      setDocumentPath(getDocumentPath(document));
      if (document.pdfconversion) {
        setIsConvertedFile(true);
      }
    }
  }, [document, documentPath]);
  return (
    <div>
      <Page
        noPaddingTop
        minFullHeight
        hideHeader
        noPadding
        maxWidth={false}
        className={isDesktop ? classes.previewPage : classes.previewPageMobile}
        contentClass={classes.contentClass}
      >
        {document && (!documentPath || !document.documentFileAvailable) && (
          <ShowErrorMessage noFile />
        )}
        {documentPath && document?.documentFileAvailable && (
          <FileViewer
            documentData={document}
            document={documentId}
            fetching={fetching}
            filePath={documentPath}
            fileType={getDocumentFileType(document)}
            isConvertedFile={isConvertedFile}
          />
        )}
      </Page>
    </div>
  );
};

export default withStyles(styles)(Document);
